<div class="inline-flex items-center gap-2 rounded-full bg-states-purple-light pr-1" data-testid="auto-start-prompt-root">
  <button
    type="button"
    class="flex size-10 shrink-0 items-center justify-center rounded-full bg-states-purple-light text-states-purple shadow-[0px_0px_6px_0px_rgba(10,72,131,0.24)] hover:cursor-pointer"
    [attr.aria-label]="'auto_start_prompt_expand_label' | translate"
    (click)="onExpandClick()"
  >
    <svg-icon key="px-16-eq" size="md"></svg-icon>
  </button>

  <button
    type="button"
    class="flex h-[30px] items-center rounded-full bg-states-purple pr-[5px] text-text-white hover:cursor-pointer hover:bg-states-purple-dark"
    data-testid="auto-start-prompt-start"
    (click)="onStartClick()"
  >
    <span class="-mr-[5px] flex items-center p-[5px]">
      <svg-icon key="px-24-play-2" size="sm"></svg-icon>
    </span>
    <span class="typo-h5-semibold flex h-full items-center justify-center whitespace-nowrap p-[5px]">
      {{ 'auto_start_prompt_start_appointment_button' | translate }}
    </span>
  </button>

  <button
    type="button"
    class="flex size-6 shrink-0 items-center justify-center text-states-purple hover:cursor-pointer"
    data-testid="auto-start-prompt-info"
    [attr.aria-label]="'auto_start_prompt_info_label' | translate"
    [libUiTooltip]="consentInfoTooltip"
    tooltipPanelClass="auto-draft-consent-tooltip"
    tooltipPosition="bottom"
  >
    <svg-icon key="px-24-info" size="md"></svg-icon>
  </button>
</div>

<ng-template #consentInfoTooltip>
  <div class="typo-h5-book flex w-[240px] flex-col gap-2 text-start text-text-secondary">
    <p>{{ 'auto_start_prompt_info_line_1' | translate }}</p>
    <p>&nbsp;</p>
    <p>{{ 'auto_start_prompt_info_line_2' | translate }}</p>
  </div>
</ng-template>
